import { Text } from '@cinch-labs/design-system'
import { VehicleListing } from '@cinch-nx/data-search'
import styles from './carousel-section.module.css'
import { useFavouritesStore } from '@cinch-nx/data-favourites'
import { useEffect, useState } from 'react'
import { CarouselWithControls } from './carousel-with-controls'
import { SoldByPartnerInfo } from '@cinch-nx/feature-new-cars-drawer'

export interface CarouselSectionProps {
  title?: string
  disclaimer?: string
  vehicles?: VehicleListing[]
  onlyShowAvailableVehicles?: boolean
  showBrowseAllCarsCard?: boolean
}

export function CarouselSection({
  title,
  disclaimer,
  vehicles,
  onlyShowAvailableVehicles = true,
  showBrowseAllCarsCard = false,
}: CarouselSectionProps) {
  const { favourites, toggleFavourite } = useFavouritesStore()
  const [availableVehicles, setAvailableVehicles] = useState<VehicleListing[]>(
    [],
  )
  useEffect(() => {
    if (vehicles && onlyShowAvailableVehicles) {
      setAvailableVehicles(
        vehicles
          .filter((vehicle) => !vehicle.isReserved && vehicle.isAvailable)
          .slice(0, 6),
      )
    }
  }, [vehicles])

  if (availableVehicles?.length) {
    return (
      <section className={styles.container}>
        <div className={styles.header}>
          {title && (
            <Text
              className={styles.title}
              element={'h2'}
              fontSizeFixed={'xl'}
              fontWeight={'bold'}
            >
              {title}
            </Text>
          )}
          {disclaimer && (
            <div className={styles.disclaimerContainer}>
              <SoldByPartnerInfo
                callToActionClassName={styles.disclaimer}
                callToActionText={disclaimer}
              />
            </div>
          )}
        </div>

        <CarouselWithControls
          vehicles={availableVehicles}
          onSaveButtonClick={toggleFavourite}
          favourites={favourites
            .map((favourite) => (favourite.vehicle ? favourite.vehicle : null))
            .filter((vehicle) => !!vehicle)}
          showBrowseAllCarsCard={showBrowseAllCarsCard}
        />
      </section>
    )
  }

  return null
}

export default CarouselSection
